import { AnalyticsBrowser } from '@segment/analytics-next'

import { VantageUser } from '../types/VantageUser'

export const analytics = new AnalyticsBrowser()

type IdentifyPayload = {
  user: VantageUser
  environment: string
}

type GroupPayload = {
  groupId: string
  traits: {
    brand: string
    retailer: string
  }
  environment: string
}

export const analyticsIdentify = ({ user, environment }: IdentifyPayload) => {
  if (!environment) return

  const envPrefix = getEnvPrefix(environment)
  const userId = getUserId(user)
  const compositeUserId = [envPrefix, userId].filter(Boolean).join('_')
  const traits = getUserTraits(user)

  analytics.identify(compositeUserId, traits)
}

export const analyticsGroup = ({ groupId, traits, environment }: GroupPayload) => {
  if (!environment) return

  const envPrefix = getEnvPrefix(environment)
  const compositeGroupId = [envPrefix, groupId].filter(Boolean).join('_')

  analytics.group(compositeGroupId, traits)
}

export const getEnvPrefix = (environment: string): string => {
  switch (environment) {
    case 'development':
      return 'dev'
    case 'staging':
      return 'stg'
    case 'release':
      return 'rls'
    case 'production':
      return ''
    default:
      return `${environment}`
  }
}

export const getUserId = (user: VantageUser): string => {
  if (user.impersonator) {
    return `${user.id}_impersonated_by_${user.impersonator.id}`
  }
  if (user.email.includes('@gotvantage.com') || user.email.includes('@vantageanalytics.com')) {
    return `internal_${user.id}`
  }
  return user.id.toString()
}

type UserTraits = {
  email: string
  name: string
  activeRole: string | null
  impersonatedBy?: string
}

export const getUserTraits = (user: VantageUser): UserTraits => {
  const traits: UserTraits = {
    email: user.email,
    name: `${user.firstName} ${user.lastName}`,
    activeRole: user.activeRole,
  }
  if (user.impersonator) {
    traits.impersonatedBy = `${user.impersonator.firstName} ${user.impersonator.lastName}`
  }

  return traits
}
